import { parseSearch } from "@faire/next-utils/lib/parseSearch";
import { match as matchDiscoverRoute } from "@faire/web-api--source/routes/www/discover/searchTerm/match";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useSearchPageParsedSearch = () => {
  const { search, pathname } = useLocation();

  const searchTerm = matchDiscoverRoute(pathname)?.params.searchTerm;

  return useMemo(
    () =>
      parseSearch({
        search: search,
        discoverSearchTerm: searchTerm,
      }),
    [search, searchTerm]
  );
};
